import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import SharedLayout from './pages/SharedLayout';
import SklepyFirmowe from './pages/SklepyFirmowe';
import Oferta from './pages/Oferta';
import Products from './pages/Products';
import About from './pages/About';
import Test from './pages/Test';
import NewsPage from './pages/NewsPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <BrowserRouter>
      <ToastContainer className="fixed" position="top-right" hideProgressBar />
      <Routes>
        <Route path="/" element={<SharedLayout />}>
          <Route index element={<Home />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/nasza_firma" element={<About />} />
          <Route path="/sklepy_firmowe" element={<SklepyFirmowe />} />
          <Route path="/aktualnosci" element={<NewsPage />} />
          <Route path="/oferta" element={<Oferta />} />
          <Route path="/oferta/:product" element={<Products />} />
          <Route path="/test" element={<Test />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
